(function() {
  function initAnimations() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    var blocks = document.querySelectorAll('.gf-reveal');
    blocks.forEach(function(el) { observer.observe(el); });

    var items = document.querySelectorAll('.gf-reveal-item');
    items.forEach(function(el, i) {
      el.style.transitionDelay = (i * 0.07) + 's';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();